<template>
  <div
    class="display-template-single-default"
    :class="{
      'iconed': leftIcon,
      'colored': displayColor
    }"
  >
    <p4a-icon
      class="left-icon"
      v-if="leftIcon"
      :icon="leftIcon"
    />

    <div
      class="color-swatch"
      :class="{
        'clear': !colorValue
      }"
      v-if="displayColor"
      :style="{
        'background-color': colorValue
      }"
    />

    <label
      class="current-value"
      v-if="value"
      v-text="displayText"
      :title="displayText"
    />
    <label
      class="search-placeholder"
      v-if="!value"
      v-text="placeHolder"
    />
  </div>
</template>

<script>
  export default {
    name: 'DisplayTemplateSingleDefault',
    components: {
    },
    data () {
      return {
        selectedOptions: {}
      }
    },
    props: {
      value: {
        default: function () {
          return null
        },
        type: Object
      },
      settings: {
        default: function () {
          return {
            displayKey: '',
            displayColor: false,
            colorKey: '',
            leftIcon: ''
          }
        },
        type: Object
      }
    },
    methods: {
    },
    computed: {
      selectionHeight () {
        return this.tall ? 50 : 28
      },
      displayColor () {
        return this.settings.displayColor
      },
      colorValue () {
        let self = this
        let result = null
        if (self.value && self.settings.colorKey) {
          result = '#' + self.value[self.settings.colorKey]
        }
        return result
      },
      displayText () {
        let self = this
        let result = null
        if (self.value && self.settings.displayKey) {
          result = self.value[self.settings.displayKey]
        }
        return result
      },
      placeHolder () {
        let self = this
        return self.settings.placeHolder
      },
      leftIcon () {
        let self = this
        return self.settings.leftIcon
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../../uikit';

  input {
    font-size: 14px;
  }

  .display-template-single-default {
    cursor: inherit;
    padding-left: 10px;

    .left-icon {
      height: 18px;
      width: 18px;
      line-height: 18px;
      display: inline-block;
      vertical-align: middle;
    }

    .color-swatch {
      display: inline-block;
      vertical-align: middle;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      margin: 0 5px 0 0;
      border: 1px dashed transparent;

      &.clear {
        border-color: $primaryBorderColor;
      }
    }

    label {
      cursor: inherit;
      display: inline-block;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      max-width: 100%;
      overflow: hidden;
      padding-right: 10px;
      text-overflow: ellipsis;
      vertical-align: middle;
      white-space: nowrap;

      &.search-placeholder {
        color: $lightGreyFont;
        cursor: inherit;
      }
    }

    &.colored {
      label {
        padding-left: 10px;
        max-width: calc(100% - 30px);
      }
    }

    &.iconed {
      label {
        padding-left: 10px;
        max-width: calc(100% - 35px);
      }

      &.colored{
        label {
          max-width: calc(100% - 60px);
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/display-templates/default/DisplayTemplateSingleDefault.vue